
















import { Component, Vue, Prop} from 'vue-property-decorator';

@Component
export default class empty extends Vue {
  @Prop(String) name:String|undefined;
  @Prop(Array) tables: any;
  created () {
    console.log(this.tables);
    
  }
}
